import { useState } from 'react';
import { visibleInputFieldStyles } from '../sofabuddyConfig';

const useChatInitialization = ({
  dailyRemainingSofabuddyMessages,
  sofabuddyCookieExists,
  triggerSurvey,
  goToPath,
  setMessages,
  setSettings,
  setStyles,
  amplitude_tracking
}) => {
  const [usageCounter, setUsageCounter] = useState(
    dailyRemainingSofabuddyMessages
  );

  const disableChat = () => {
    setStyles(prevStyles => ({
      ...prevStyles,
      ...visibleInputFieldStyles
    }));
    amplitude_tracking('sofabuddy_daily_message_limit_reached');
    goToPath('end');
  };

  const resumeChat = () => {
    setMessages(prev => prev.filter(msg => msg.sender !== 'system'));
    setSettings(prevSettings => ({
      ...prevSettings,
      chatHistory: {
        ...prevSettings.chatHistory,
        disabled: false
      }
    }));
    setStyles(prevStyles => ({
      ...prevStyles,
      ...visibleInputFieldStyles
    }));
    goToPath('welcome');
  };

  const initializeChat = () => {
    if (usageCounter <= 0) {
      disableChat();
    } else if (!sofabuddyCookieExists) {
      goToPath('intro');
    } else {
      resumeChat();
      if (sofabuddyCookieExists) triggerSurvey();
    }
  };

  return {
    usageCounter,
    setUsageCounter,
    initializeChat,
    resumeChat,
    disableChat
  };
};

export default useChatInitialization;
